import { render, staticRenderFns } from "./QuestionsTypeInfo.vue?vue&type=template&id=4a3cbbfa&scoped=true&"
import script from "./QuestionsTypeInfo.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3cbbfa",
  null
  
)

export default component.exports